<template>
	<base-layout>
		<template v-slot:header>
			Diamond Members
		</template>

		<template v-slot:main>
			<div>
				<div class="mb-6 rounded-2xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-6 shadow-sm">
				<div class="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
					
					<!-- Left content -->
					<div class="flex-1">
						<h2 class="mb-2 text-lg font-semibold text-gray-900">
							TBS Diamond Members
						</h2>

						<p class="mb-4 text-sm text-gray-500">
							Long-standing computer brokers with an exceptional track record on www.TheBrokerSite.com
						</p>

						<p class="text-sm leading-6 text-gray-700">
							Diamond Members have been on www.TheBrokerSite.com for <strong>20</strong> or more years, we do not have any unsolved complaints on file and they offer a 1 month return to base warranty.
						</p>

						<div class="mt-5">
							<div class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
								Why these companies are diamond members
							</div>

							<div class="grid gap-3 sm:grid-cols-3">
								<div class="flex items-center gap-2 text-sm text-gray-700">
									<span class="text-green-600">✔</span>
									<span>20+ years active</span>
								</div>

								<div class="flex items-center gap-2 text-sm text-gray-700">
									<span class="text-green-600">✔</span>
									<span>No unresolved complaints</span>
								</div>

								<div class="flex items-center gap-2 text-sm text-gray-700">
									<span class="text-green-600">✔</span>
									<span>1-month RTB warranty</span>
								</div>
							</div>
						</div>

						<p class="mt-4 text-xs leading-5 text-gray-500">
							These verified business sellers are part of TheBrokerSite’s global IT hardware trading marketplace and represent some of the most established and reliable suppliers in our network.
						</p>

						<p class="mt-4 text-sm text-gray-600">
							Our current listing has <strong class="text-red-600">{{ companies.length }}</strong> diamond members.
						</p>
					</div>

					<!-- Right seal -->
					<div class="flex justify-center sm:block">
						<div class="member_diamond shrink-0"></div>
					</div>
				</div>
			</div>

				<!-- Filters -->
				<div class="mb-6 rounded-2xl border border-gray-200 bg-white/90 p-4 shadow-sm">
					<div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
						<div class="relative flex-1">
							<div class="pointer-events-none absolute -z-10 h-0 w-0 overflow-hidden opacity-0" aria-hidden="true">
								<input type="text" name="email" autocomplete="email" tabindex="-1" />
								<input type="password" name="password" autocomplete="current-password" tabindex="-1" />
							</div>
							<input
								v-model.trim="search"
								type="text"
								:name="searchInputName"
								autocomplete="one-time-code"
								autocapitalize="off"
								autocorrect="off"
								spellcheck="false"
								:readonly="searchInputLocked"
								@focus="unlockSearchInput"
								@mousedown="unlockSearchInput"
								@keydown="unlockSearchInput"
								placeholder="Search company name, profile, country, city..."
								class="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 pr-10 text-sm text-gray-800 placeholder-gray-400 transition focus:border-red-500 focus:bg-white focus:outline-none"
							/>
							<button
								v-if="search"
								@click="search = ''"
								type="button"
								class="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-400 transition hover:text-gray-700"
							>
								✕
							</button>
						</div>

						<div class="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
							<select
								v-model="selectedCountry"
								class="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700 transition focus:border-red-500 focus:bg-white focus:outline-none"
							>
								<option value="">All countries</option>
								<option
									v-for="country in availableCountries"
									:key="country"
									:value="country"
								>
									{{ country }}
								</option>
							</select>

							<select
								v-model="sortBy"
								class="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700 transition focus:border-red-500 focus:bg-white focus:outline-none"
							>
								<option value="name_asc">Name A-Z</option>
								<option value="name_desc">Name Z-A</option>
								<option value="since_desc">Recently diamond</option>
								<option value="since_asc">Diamond longest</option>
							</select>

							<select
								v-model.number="perPage"
								class="rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-700 transition focus:border-red-500 focus:bg-white focus:outline-none"
							>
								<option :value="8">8 per page</option>
								<option :value="12">12 per page</option>
								<option :value="16">16 per page</option>
								<option :value="20">20 per page</option>
							</select>

							<button
								v-if="search || selectedCountry || sortBy !== 'name_asc' || perPage !== 12"
								@click="resetFilters"
								type="button"
								class="rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition hover:bg-gray-50"
							>
								Reset
							</button>
						</div>
					</div>

					<div class="mt-3 flex flex-wrap items-center justify-between gap-2 text-sm text-gray-500">
						<p>
							Showing <strong class="text-gray-700">{{ filteredCompanies.length }}</strong> diamond member<span v-if="filteredCompanies.length !== 1">s</span>
						</p>
						<div class="flex flex-wrap items-center gap-3">
							<p v-if="selectedCountry">
								Country: <strong class="text-gray-700">{{ selectedCountry }}</strong>
							</p>
							<p v-if="search">
								Search term: <strong class="text-gray-700">"{{ search }}"</strong>
							</p>
						</div>
					</div>
				</div>

				<!-- Cards -->
				<div
					v-if="paginatedCompanies.length"
					class="grid grid-cols-1 gap-4 xl:grid-cols-2"
				>
					<div
						v-for="item in paginatedCompanies"
						:key="item.id"
						class="group flex h-full min-w-0 flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition duration-200 hover:shadow-md"
					>
						<div class="flex min-w-0 items-start gap-4">
							<div
								class="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-gray-200 bg-gradient-to-br from-gray-50 to-gray-100"
							>
								<img
									v-if="!item.logoError"
									:src="getLogoUrl(item.username)"
									@error="item.logoError = true"
									class="h-full w-full object-contain p-2"
								/>

								<div
									v-else
									class="flex h-full w-full items-center justify-center text-base font-semibold tracking-wide text-gray-500"
								>
									{{ getInitials(item.name) }}
								</div>
							</div>

							<div class="min-w-0 flex-1">
								<h3 class="truncate text-lg font-semibold text-gray-900">
									{{ item.name }}
								</h3>

								<div class="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-500">
									<span v-if="item.country">{{ item.country }}</span>
									<span v-if="item.country && item.city">•</span>
									<span v-if="item.city">{{ item.city }}</span>
									<span v-if="item.sinceDT">•</span>
									<span v-if="item.sinceDT">Diamond since {{ formatSince(item.sinceDT) }}</span>
								</div>

								<div class="mt-2">
									<span class="inline-flex items-center rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-600">
										Diamond Member
									</span>
								</div>

								<p class="mt-3 line-clamp-3 text-sm leading-6 text-gray-600">
									{{ getProfileExcerpt(item) }}
								</p>
							</div>
						</div>

						<div class="mt-auto border-t border-gray-100 pt-4">
							<div class="flex items-center justify-between gap-3">
								<button
									@click="navToCompany(item)"
									class="inline-flex items-center justify-center rounded-xl bg-red-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-red-700"
								>
									TBS Profile
								</button>

								<a
									v-if="item.website"
									:href="normalizeUrl(item.website)"
									target="_blank"
									rel="noopener noreferrer"
									class="inline-flex items-center justify-center rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:bg-gray-50"
								>
									Visit Website
								</a>
							</div>
						</div>
					</div>
				</div>

				<div v-else class="rounded-2xl border border-gray-200 bg-gray-50 p-6 text-sm text-gray-600">
					No diamond members found for your current filter.
				</div>

				<!-- Pagination -->
				<div
					v-if="totalPages > 1"
					class="mt-8 flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between"
				>
					<p class="text-sm text-gray-600">
						Showing {{ pageStart + 1 }}-{{ pageEnd }} of {{ filteredCompanies.length }}
					</p>

					<div class="flex flex-wrap items-center gap-2">
						<button
							@click="prevPage"
							:disabled="currentPage === 1"
							class="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
						>
							Previous
						</button>

						<div class="flex items-center gap-1">
							<button
								v-for="page in visiblePages"
								:key="page"
								@click="goToPage(page)"
								:class="[
									'min-w-[40px] rounded-xl px-3 py-2 text-sm transition',
									page === currentPage
										? 'bg-red-600 text-white shadow-sm'
										: 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
								]"
							>
								{{ page }}
							</button>
						</div>

						<button
							@click="nextPage"
							:disabled="currentPage === totalPages"
							class="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
						>
							Next
						</button>
					</div>
				</div>
			</div>
		</template>
	</base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import BaseLayout from '@/components/BaseLayout.vue'

export default {
	name: 'DiamondMembers',
	components: {
		BaseLayout,
	},
	data: () => ({
		companies: [],
		search: '',
		searchInputLocked: true,
		searchInputName: `company-search-${Math.random().toString(36).slice(2, 10)}`,
		selectedCountry: '',
		sortBy: 'name_asc',
		currentPage: 1,
		perPage: 12,
	}),
	async created() {
		const res = await this.getDiamondMembers()
		this.companies = res.payload.results.map(c => ({
			...c,
			logoError: false
		}))
	},
	computed: {
		availableCountries() {
			return [...new Set(
				this.companies
					.map(item => (item.country || '').trim())
					.filter(Boolean)
			)].sort((a, b) => a.localeCompare(b))
		},
		filteredCompanies() {
			const search = this.search.toLowerCase()

			let results = this.companies.filter((item) => {
				const haystack = [
					item.name,
					item.profile,
					item.description,
					item.country,
					item.city,
					item.website,
				]
					.filter(Boolean)
					.join(' ')
					.toLowerCase()

				const matchesSearch = haystack.includes(search)
				const matchesCountry = !this.selectedCountry || item.country === this.selectedCountry

				return matchesSearch && matchesCountry
			})

			results = [...results].sort((a, b) => {
				if (this.sortBy === 'name_asc') {
					return (a.name || '').localeCompare(b.name || '')
				}
				if (this.sortBy === 'name_desc') {
					return (b.name || '').localeCompare(a.name || '')
				}
				if (this.sortBy === 'since_desc') {
					return new Date(b.sinceDT || 0) - new Date(a.sinceDT || 0)
				}
				if (this.sortBy === 'since_asc') {
					return new Date(a.sinceDT || 0) - new Date(b.sinceDT || 0)
				}
				return 0
			})

			return results
		},
		totalPages() {
			return Math.ceil(this.filteredCompanies.length / this.perPage) || 1
		},
		paginatedCompanies() {
			const start = (this.currentPage - 1) * this.perPage
			const end = start + this.perPage
			return this.filteredCompanies.slice(start, end)
		},
		pageStart() {
			return (this.currentPage - 1) * this.perPage
		},
		pageEnd() {
			return Math.min(this.pageStart + this.perPage, this.filteredCompanies.length)
		},
		visiblePages() {
			const pages = []
			const start = Math.max(1, this.currentPage - 2)
			const end = Math.min(this.totalPages, this.currentPage + 2)

			for (let i = start; i <= end; i++) {
				pages.push(i)
			}
			return pages
		},
	},
	watch: {
		search() {
			this.currentPage = 1
		},
		selectedCountry() {
			this.currentPage = 1
		},
		sortBy() {
			this.currentPage = 1
		},
		perPage() {
			this.currentPage = 1
		},
		filteredCompanies() {
			if (this.currentPage > this.totalPages) {
				this.currentPage = this.totalPages
			}
		},
	},
	methods: {
		...mapActions(['getDiamondMembers']),
		getLogoUrl(username) {
			return `https://www.thebrokersite.com/images/logos/${username}.jpg`
		},
		onLogoError(event) {
			event.target.src = this.getLogoUrl('no_logo')
		},
		unlockSearchInput() {
			if (this.searchInputLocked) {
				this.searchInputLocked = false
			}
		},
		formatSince(date) {
			if (!date) return 'N/A'
			const options = { year: 'numeric', month: 'short', day: 'numeric' }
			return new Date(date).toLocaleDateString('en', options)
		},
		getInitials(name) {
			if (!name) return 'N/A'
			return name
				.split(' ')
				.slice(0, 2)
				.map((word) => word.charAt(0).toUpperCase())
				.join('')
		},
		getProfileExcerpt(item) {
			const text =
				item.profile ||
				item.description ||
				`${item.name} is a Diamond Member of TheBrokerSite.`

			return text.length > 155 ? text.substring(0, 152) + '...' : text
		},
		normalizeUrl(url) {
			if (!url) return ''
			return /^https?:\/\//i.test(url) ? url : `https://${url}`
		},
		navToCompany(item) {
			this.$router.push({ name: 'companyDetail', params: { id: item.id } })
		},
		goToPage(page) {
			this.currentPage = page
			window.scrollTo({ top: 0, behavior: 'smooth' })
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--
				window.scrollTo({ top: 0, behavior: 'smooth' })
			}
		},
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++
				window.scrollTo({ top: 0, behavior: 'smooth' })
			}
		},
		resetFilters() {
			this.search = ''
			this.selectedCountry = ''
			this.sortBy = 'name_asc'
			this.perPage = 12
			this.currentPage = 1
		},
	},
}
</script>

<style scoped>
.line-clamp-3 {
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.member_diamond {
  width: 120px;
  height: 120px;
  background: url("../assets/diamond.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: drop-shadow(0 6px 16px rgba(0,0,0,0.12));
}
</style>